import { addressComparisonKey, addressesEqual } from "./aptos-address";

// Changing a salt reshuffles every live rollout bucket for that config.
export const AGENT_MODE_CONFIG = "agent_mode";
export const AGENT_MODE_ROLLOUT_SALT = "agent_mode";
export const FUN_DEPOSITS_CONFIG = "fun_deposits";
export const FUN_ROLLOUT_SALT = "fun_deposits";

/** Deterministic FNV-1a bucket in [0, 100); per-feature salts keep rollouts independent. */
export function rolloutBucket(salt: string, key: string): number {
  const input = `${salt}:${key}`;
  let hash = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0) % 100;
}

export interface AddressRollout {
  enabled: boolean;
  allowedAddresses: readonly string[];
  rolloutPercent: number;
}

export function isAddressInRollout(
  rollout: AddressRollout,
  salt: string,
  accountAddress: string | undefined,
): boolean {
  if (rollout.enabled) return true;
  if (!accountAddress) return false;
  if (rollout.allowedAddresses.some((address) => addressesEqual(address, accountAddress))) {
    return true;
  }
  return rolloutBucket(salt, addressComparisonKey(accountAddress)) < rollout.rolloutPercent;
}
